<template>
  <div class="station-base-container">
    <BaseGroupTotal v-if="selectedNode.type != productCodes.station" />
    <BaseStationTotal v-else />
    <BaseGroupList v-if="selectedNode.type != productCodes.station" style="margin-top:15px;" />
    <template v-else>
      <BaseStationList ref="lightList1" style="margin-top:15px;" />
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import BaseGroupTotal from './layout/GroupTotal'
import BaseGroupList from './layout/GroupList'
import BaseStationTotal from './layout/StationTotal'
import BaseStationList from './layout/StationList'
export default {
  name: 'StationBaseIndex',
  components: {
    BaseGroupTotal,
    BaseStationTotal,
    BaseGroupList,
    BaseStationList,
  },
  props: {
  },
  data() {
    return {
      organMaintenance: {},
      organOwner: {},
      visible: false,
      showLightArgModal: false,
      showMonitorModal: false,
      cmdType: 'powerbox',
      showCheckAuthModal: false,
      checkAuthModalSuccessFunction: null,
      checkAuthModalUsers: [],
      cmdItem: {},
      lightStyle: 'config', //单灯标签页： config = 组态，list = 列表
      showControlTimeModal: false,
      showViewTimeModal: false,
      modal: 'alarm', //base, ctrl, alarm, analysis,
      orders: [],
      remotes: [],
      pageId: 0,
      deviceCode: '',
      pages: [],
      commandItem: {},
      info: { organs: '', road: '', rule: {} },
      cmdIds: [],
      powerTableActions: {
        0: '关闭',
        1: '开启',
        2: '无效'
      }
    }
  },
  computed: {
    ...mapGetters('group', ['groupPathName']),
    ...mapGetters('auth', ['showLang']),
    ...mapState("cmd", ["commands", "cmdResultRefresh"]),
    ...mapState('common', ['weeks', 'productCodes', 'deviceTypes', 'monitorActionTypes']),
    ...mapState('group', ['selectedDevices', 'selectedNode']),
    ...mapState('auth', ['showSpin', 'stationTabName']),
    currentStation: function () {
      if (this.selectedNode.type == this.productCodes.station) {
        return this.selectedNode;
      }
      return null;
    },
    hasPowerBox: function () {
      return this.selectedNode.type == this.productCodes.station && this.selectedNode.hasPower;
    },
    hasLight: function () {
      return this.selectedNode.type == this.productCodes.station && this.selectedNode.hasLight;
    },
    onlyLeakage: function () {
      return this.selectedNode.type == this.productCodes.station && !this.selectedNode.hasControl;
    },
  },
  watch: {
    selectedNode() {
    },
    cmdResultRefresh() {
      this.cmdResultChanged()
    },
  },
  mounted: function () {
    this.powerTableActions = {
      0: this.showLang('com.op.close'),// '关闭',
      1: this.showLang('com.state.open'),// '开启',
      2: this.showLang('com.state.invalid'),// '无效'
    }
  },
  destroyed: function () {
  },
  methods: {
    getCmdStatus: function (cmd) {
      let p = '<p>', p1 = '</p>';
      if (this.stationTabName == 'light') {
        p = '';
        p1 = ' ';
      }
      let content = `${p}${this.showLang('com.ins.create')}${p1}`;
      if (cmd.status == 1) {
        if (cmd.args.channel) {
          content = `${p}${this.showLang('com.ins.ch.reply', cmd.args.channel)}${p1}`;

        } else {
          content = `${p}${this.showLang('com.ins.dev.reply')}${p1}`
        }
      }
      else if (cmd.status == 3) {
        if (cmd.args.channel) {
          content = `${p}${this.showLang('com.ins.ch')}K${cmd.args.channel}${this.showLang('com.ins.fail')}：${cmd.result}${p1}`;
        } else {
          content = `${p}${this.showLang('com.ins.fail')}：${cmd.result}${p1}`
        }
      } else if (cmd.status == 4) {
        if (cmd.args.channel) {
          content = `${p}${this.showLang('com.ins.ch')}K${cmd.args.channel}${this.showLang('com.ins.execution')}：${cmd.content.pkg} / ${cmd.content.total}${p1}`;
        } else {
          content = `${p}${this.showLang('com.ins.execution')}：${cmd.content.pkg} / ${cmd.content.total}${p1}`
        }
      } else if (cmd.status == 5) {
        if (cmd.args.channel) {
          content = `${p}${this.showLang('com.ins.ch')}K${cmd.args.channel}${this.showLang('com.ins.fail.retry')}：${cmd.result}${p1}`;
        } else {
          content = `${p}${this.showLang('com.ins.fail.retry')}：${cmd.result}${p1}`;
        }
      } else if (cmd.status == 9) {
        if (cmd.code == "getTimeTable") {
          let day = "day" + cmd.args.day;
          let con = cmd.content[day];
          content = `${p}${this.showLang('com.ins.timeTable')}：${cmd.args.month}${this.showLang('com.date.month')}${cmd.args.day}${this.showLang('com.date.sun')}<br> ${con.t1} - ${this.powerTableActions[con.a1]}<br>${con.t2} - ${this.powerTableActions[con.a2]}<br> ${con.t3} - ${this.powerTableActions[con.a3]}<br> ${con.t4} - ${this.powerTableActions[con.a4]}${p1}`;
        } else if (cmd.code == "getclock") {
          content = `${p}${this.showLang('com.ins.dev.currentTime')}: ${cmd.content.nowTime}${p1}`;
        } else if (cmd.code == "setclock") {
          let myDate = new Date();
          content = `${p}${this.showLang('com.but.get.Calibrate')}: ${myDate.format('yyyy-MM-dd HH:mm:ss')}${p1}`;
        } else if (cmd.code == 'getYearPlan') {
          // console.log('get year plan', cmd)
          if (cmd.args.month != cmd.content.month) {
            content = `${p}${this.showLang('com.ins.success.WrongMonth', cmd.args.month)}${cmd.content.month}${p1}`;
          } else {
            let strs = [];
            let obj = cmd.content[`day${cmd.args.day}`];
            if (cmd.content.mode == 4) { //北京模式
              for (let i = 1; i <= 4; i++) {
                let ao = this.powerTableActions[obj[`a${i}`]];
                let to = obj[`o${i}`];
                // let ac = this.powerTableActions[obj[`ac${i}`]];
                let tc = obj[`c${i}`];
                strs.push(`${p}${i}、${to}-${tc}:${ao}${p1}`);
              }
            } else if (cmd.content.mode == 5) { //集中器模式
              for (let i = 1; i <= 6; i++) {
                let a = obj[`a${i}`]; //this.monitorActionTypes[];
                let t = obj[`t${i}`];
                let v = this.monitorActionTypes[a]; //a == 1 ? '' : obj[`v${i}`];
                if (a != 1) {
                  v += ` - ${obj[`v${i}`]}`
                }
                strs.push(`${p}${i}、${t} - ${v}${p1}`);
              }
            } else {
              for (let i = 1; i <= 4; i++) {
                let a = this.powerTableActions[obj[`a${i}`]];
                let t = obj[`t${i}`];
                strs.push(`${p}${i}、${t} - ${a}${p1}`);
              }
            }
            content = `${p}${this.showLang('com.ins.ch')}K${cmd.args.channel}${this.showLang('com.ins.success')}：${cmd.args.month}${this.showLang('com.date.month')}${cmd.args.day}${this.showLang('com.date.sun')}${this.showLang('com.date.plan')}：${strs.join(' ')}${p1}`
          }
        } else if (cmd.code == 'getInfo') {
          content = `${p}${this.showLang('com.site.hw')}：${cmd.content.hardware}${p1}${p}${this.showLang('com.site.sw')}：${cmd.content.software}${p1}${p}${this.showLang('com.user.manufacturer')}：${cmd.content.manufacture}${p1}`
        } else if (cmd.code == 'getSimInfo') {
          content = `${p}ICCID: ${cmd.content.iccid}${p1}${p}IMEI: ${cmd.content.imei}${p1}${p}RSSI: ${cmd.content.rssi}${p1}`
        } else if (cmd.code == 'getNetwork') {
          content = `${p}IP:${cmd.content.host}${p1}${p}${this.showLang('com.ins.port')}:${cmd.content.port}${p1}${p}${this.showLang('com.ins.heartbeat')}:${cmd.content.heart}S${p1}`
        } else if (cmd.code == 'getDayPlan1') {
          let str = '';
          for (let n = 0; n < 6; n++) {
            let item = cmd.content[n];
            if (!item) continue;
            str += `${this.showLang('com.date.period')}${n + 1}，${this.showLang('com.date.time')}：${item.min}min，`;
            for (let c = 0; c < 4; c++) {
              let bright = item[`ch${c + 1}`];
              let color = item[`c${c + 1}`];
              if (bright != undefined) {
                str += `${c + 1}${this.showLang('com.ins.ch.light')}：${bright}，`;
              }
              if (color != undefined) {
                str += `${c + 1}${this.showLang('com.ins.ch.color')}：${color}，`;
              }
            }
          }
          content = str;
        } else if (cmd.code == 'getDayPlan2') {
          let str = '';
          for (let n = 0; n < 6; n++) {
            let item = cmd.content[n];
            if (!item) continue;
            str += `${this.showLang('com.date.period')}${n + 1}，${this.showLang('com.date.time')}：${item.min}min，`;
            for (let c = 0; c < 4; c++) {
              let bright = item[`ch${c + 1}`];
              let color = item[`c${c + 1}`];
              if (bright != undefined) {
                str += `${c + 1}${this.showLang('com.ins.ch.light')}：${bright}，`;
              }
              if (color != undefined) {
                str += `${c + 1}${this.showLang('com.ins.ch.color')}：${color}，`;
              }
            }
          }
          content = str;
        } else if (cmd.code == 'getGroup') {
          content = `${p}${this.showLang('com.group.number')}: ${cmd.content.no}${p1}`
        } else if (cmd.code == 'getPlanType') {
          content = `${p}${this.showLang('com.but.tableType')}: ${cmd.content.type == 0 ? this.showLang("com.but.timing") : this.showLang("com.but.ontime")}`
        } else if (cmd.code == 'getAlarmRange') {
          content = `${this.showLang('com.lighting.V.min')}：${cmd.content.vLow}；
                ${this.showLang('com.lighting.V.max')}：${cmd.content.vHigh}；
                ${this.showLang('com.lighting.I.min')}：${cmd.content.cLow}；
                ${this.showLang('com.lighting.I.max')}：${cmd.content.cHigh}；
                ${this.showLang('com.lighting.T.min')}：${cmd.content.tLow}；
                ${this.showLang('com.lighting.T.max')}：${cmd.content.tHigh}；
                ${this.showLang('com.ins.escalation.heartbeat')}：${cmd.content.interval}min；`
        } else if (cmd.code == 'getUnionParam') {
          content = `
              <p>${this.showLang('com.lighting.delay.lamp1')}：${cmd.content.keep1}s</p>
              <p>${this.showLang('com.lighting.delay.lamp2')}：${cmd.content.keep2}s</p>
              <p>${this.showLang('com.lighting.is.sensing')}：${cmd.content.sensor == 1 ? this.showLang('com.state.effective') : this.showLang('com.state.invalid')}；</p>
              <p>${this.showLang('com.lighting.is.signal')}：${cmd.content.txen > 10 ? this.showLang('com.state.effective') : this.showLang('com.state.invalid')}；</p>
              <p>${this.showLang('com.lighting.send.cycle')}：${cmd.content.period}s</p>
              <p>${this.showLang('com.lighting.linkage.number')}：${cmd.content.rfsn}；</p>
              <p>433${this.showLang('com.lighting.send.power')}：${cmd.content.txpower}；</p>
              <p>433${this.showLang('com.lighting.channel')}：${cmd.content.channel}；</p>
              <p>${this.showLang('com.lighting.response.range')}：${cmd.content.range}；</p>
              <p>${this.showLang('com.lighting.is.put.signal')}：${cmd.content.rxen == 1 ? this.showLang('com.state.receive') : this.showLang('com.state.no.receive')}；</p>
              <p>${this.showLang('com.lighting.linkage.mode')}：${cmd.content.mode == 1 ? this.showLang('com.lighting.Linkage.control') : this.showLang('com.lighting.lamp.contact')}；</p>
              <p>${this.showLang('com.lighting.repeat.num')}：${cmd.content.repeat}；</p>
              `
        } else if (cmd.code == 'getAlarmStatus') {
          content = `${this.showLang('com.lighting.V.alarm')}：${cmd.content.voltage ? this.showLang('com.state.enable') : this.showLang('com.state.disable')}
                ${this.showLang('com.lighting.I.alarm')}：${cmd.content.current ? this.showLang('com.state.enable') : this.showLang('com.state.disable')}
                ${this.showLang('com.lighting.T.alarm')}：${cmd.content.temp ? this.showLang('com.state.enable') : this.showLang('com.state.disable')}`
        } else if (cmd.code == 'getGyroLevel') {
          content = `${this.showLang('com.but.tiltThreshold')}：${cmd.content.level}；`
        } else if (cmd.args.channel) {
          content = p + this.showLang('com.ins.ch') + 'K' + cmd.args.channel + this.showLang('com.ins.success') + p1;
        } else {
          content = p + this.showLang('com.ins.success') + p1;
        }
      }
      return content;
    },
    cmdResultChanged: function () {
      let cmds = this.commands.filter(p => this.cmdIds.indexOf(p.id) != -1);
      if (cmds.length == 0) return;
      let contents = [];
      for (let cmd of cmds) {
        if (this.stationTabName != 'light') {
          contents.push(this.getCmdStatus(cmd));
        } else {
          this.$refs.lightList1.setCmdContent(cmd.id, cmd, this.getCmdStatus(cmd));
        }
      }
      if (this.stationTabName != 'light') {
        let content = contents.join(' ');
        this.$store.commit('auth/hideSpin');
        setTimeout(() => {
          this.$Modal.success({
            title: this.showLang('com.ins.result'),
            content: content
          });
        }, 500);
      }
    },
    getBoxDeviceIds: function () {
      if (!this.currentStation) return [];
      return this.currentStation.deviceIds;
    },
    lightArgsSaved: function (params) {
      // console.log('light args saved', params);
      let cmds = [], cmdids = [];
      let chks = this.$refs.lightList1.getSelectedItems();
      let ns = [];
      // let ds = {};
      this.checkCmdAuth(this.cmdType, params.paramsCode, false, (checkResult) => {
        this.showLightArgModal = false;
        for (let chk of chks) {
          // console.log('args saved', chk);
          ns.push(chk.name);
          // ds[chk.name] = chk.topId;
          chk.result = '';
          chk.status = 0;
          let args = this.clone(params.args);// {channel: chk.channel}
          // args.channel = chk.channel;
          // params.args.channel = chk.channel;
          let code = params.code;
          if (params.code == 'openSingle' || params.code == 'closeSingle') {
            code = 'handSingle';
          } else if (params.code == 'handControl') {
            args.point = false;
            // args.expire = params.args.expire;
            // params.args.point = false;
          } else if (params.code == 'update') {
            args.flag = 1;
          }
          cmdids.push(chk.id);
          cmds.push({ id: chk.id, code: code, name: params.name, deviceId: chk.devId, checkUserId: checkResult.userId, args: args });
        }
        if (params.code == 'update') {
          this.$Modal.confirm({
            title: this.showLang('com.op.prompt'),
            content: this.showLang('com.ins.upgrade.device', ns),
            onOk: async () => {
              this.$set(this, 'cmdIds', cmdids);
              this.$store.dispatch('cmd/sendCommands', cmds);
            },
          });
        } else {
          this.$set(this, 'cmdIds', cmdids);
          this.$store.dispatch('cmd/sendCommands', cmds);
        }
      });
    },
    cmdAuthUserChecked: function(params){
      // console.log('auth user check result', params, this.checkAuthModalSuccessFunction);
      if(this.checkAuthModalSuccessFunction){
        this.checkAuthModalSuccessFunction(params);
      }
    },
    checkCmdAuth: function(type, cmdCode, isOpen, checkOkFun){
      this.$axios.post(`//${this.domains.trans}/sys/setting/CheckCmdAuth`, {type, code: cmdCode, open: isOpen}).then(res => {
        if(res.code != 0)return;
        if(!res.data.need){
          checkOkFun({userId: 0});
          return;
        }
        this.checkAuthModalSuccessFunction = checkOkFun;
        this.checkAuthModalUsers = res.data.users;
        this.showCheckAuthModal = true;
      });
    },
    doLightCmd: function (cmd) {
      // console.log('do light cmd', cmd);
      this.cmdType = 'light';
      let list = this.$refs.lightList1.getSelectedItems();
      if (list.length == 0) {
        this.$Modal.error({
          title: this.showLang('com.ins.arrange.wrong'),
          content: this.showLang('com.ins.select.lamp.controller'),
        });
        return;
      }
      if (cmd.needArgs || cmd.needPswd) {
        this.cmdItem = { paramsCode: cmd.code, code: cmd.code, name: cmd.name, pswd: cmd.needPswd, args: {} };
        this.showLightArgModal = true;
      } else {
        this.checkCmdAuth(this.cmdType, cmd.code, false, (checkResult) => {
          this.showLightArgModal = false;
          let cmds = [], cmdIds = [];
          for (let l of list) {
            if (cmds.filter(p => p.deviceId == l.pid).length > 0) continue;
            l.result = '';
            l.content = {};
            l.status = 0;
            cmdIds.push(l.id);
            cmds.push({ id: l.id, code: cmd.code, name: cmd.name, deviceId: l.devId, checkUserId: checkResult.userId, args: {}, source: "lighting" });
          }
          this.$set(this, 'cmdIds', cmdIds);
          this.$store.dispatch('cmd/sendCommands', cmds).then(res => {
            if (res.code != 0) {
              this.$Modal.error({
                title: this.showLang('com.ins.sending.error'),
                content: res.data
              });
            }
          });
        });
      }
    },
    doPowerCmd: function (cmd) {
      // console.log('do power cmd', cmd);
      this.cmdType = 'powerbox';
      let devs = this.getBoxDeviceIds();
      if (devs.length == 0) {
        this.$Modal.error({
          title: this.showLang('com.ins.arrange.wrong'),
          content: this.showLang('com.ins.no.attribute.device'),
        });
        return;
      }
      if (cmd.needArgs || cmd.needPswd) {
        cmd.type = 'power';
        cmd.devs = devs;
        this.cmdItem = cmd;
      } else {
        this.checkCmdAuth(this.cmdType, cmd.code, false, (checkResult) => {
          let cmds = [{ id: devs[0], code: cmd.code, name: cmd.name, deviceId: devs[0], checkUserId: checkResult.userId, args: {}, source: "lighting" }];
          this.$set(this, 'cmdIds', [devs[0]]);
          this.$store.commit('auth/showSpin', { content: this.showLang('com.ins.send.wait.reply'), timeout: 20 });
          this.$store.dispatch('cmd/sendCommands', cmds).then(res => {
            if (res.code != 0) {
              this.$Modal.error({
                title: this.showLang('com.ins.sending.error'),
                content: res.data
              });
            }
          });
        });
      }
    },
    switchTab: function (name) {
      this.$store.commit('auth/switchStationTabName', name);
    },
    switchStyle: function (name) {
      this.lightStyle = name;
    },
    close() {
      this.visible = false;
    },
  }
}
</script>
<style scoped>
.station-base-container {
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  /* display: flex;
  flex-direction: column;
  align-content: stretch; */
  /* border: solid 1px red; */
  /* height: 500px; */
  background-color: #e3e9ef;
}
.device-type-switch {
  position: fixed;
  top: 110px;
  right: 40px;
  z-index: 15;
  /* width: 100px;
  height: 100px; */
}
.device-type-box {
  display: inline-block;
  width: 70px;
  height: 28px;
  background: transparent;
  border: 1px solid #ffffff;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.device-type-box.device-type-success {
  color: #2965fb;
  background: #ffffff;
}
.device-type-left {
  border-radius: 14px 0px 0px 14px;
}
.device-type-rig {
  border-radius: 0px 14px 14px 0px;
}
.box-content {
  position: absolute;
  top: 110px;
  bottom: 10px;
  right: 0;
  left: 310px;
  background-color: #e3e9ef;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 300;
  /* border: solid 1px red; */
  overflow: hidden;
}
.box-body {
  height: 0;
  flex: auto;
  margin-top: 5px;
  /* border: solid 1px red; */
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
}
.box-body::-webkit-scrollbar {
  display: none;
}
.style-content {
  flex: none;
  display: flex;
  padding: 0 195px 0 30px;
  margin-bottom: 20px;
}
.box-button-list {
  position: absolute;
  right: 0;
  top: 130px;
  width: 37px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 4px 40px 0px rgba(56, 128, 252, 0.5);
  border-radius: 12px 0px 0px 12px;
}
.box-button-item {
  /* margin-top: 8px; */
  flex: none;
  width: 37px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.box-button-item img {
  width: 14px;
  height: 14px;
}
.box-button-item span {
  width: 18px;
  margin: 3px 0 0 6px;
  line-height: 14px;
  font-size: 14px;
  color: #324252;
  font-weight: 400;
}
.box-button-active span {
  color: #3880fc;
}

/* 站点信息 */
.box-header2 {
  flex: none;
  height: 172px;
  background: #fff;
  margin-top: 16px;
  position: relative;
  padding: 25px 30px;
}
.box-header2-title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #021629;
  border-bottom: 1px solid #dee5ed;
  padding-bottom: 15px;
}
.header-info-region {
  float: right;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #324252;
  margin-right: 35px;
}
.header-info {
  color: #324252;
  display: flex;
  justify-content: space-evenly;
  padding: 18px 0 5px;
}
.header-info-item {
  flex: auto;
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #324252;
}
.header-info-item img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -3px;
}
.header-info-region img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 3px;
  margin-top: -3px;
}
.header-simcard {
  height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff99;
  margin-top: 5px;
  display: flex;
  justify-content: flex-start;
}
.header-info-moreBox .simcard-item {
  margin-top: 10px;
}
.simcard-item {
  border-radius: 6px;
  line-height: 12px;
  padding: 2px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #324252;
}
.simcard-item img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-left: -2px;
  margin-top: -3px;
}
</style>